import { SpecialtyItemProps } from "apis";
import { lazy } from "react";

export const PageAdminSpecialty = lazy(() => import("./List"));
export const PageAdminSpecialtyCreate = lazy(() => import("./Add"));
export const PageAdminSpecialtyUpdate = lazy(() => import("./Edit"));

export interface FormSpecialtyValuesProps extends SpecialtyItemProps { }